import axios from "axios";

export const jwtToken = localStorage.getItem("authorization");

/*axios.interceptors.request.use(
  function(config) {

    if (jwtToken && config.url.indexOf("auth/login") === -1) {
      config.headers["authorization"] = "Bearer " + jwtToken;
    }

    return config;
  },
  function(err) {
    return Promise.reject(err);
  }
);*/

axios.interceptors.response.use(
    function (config) {
        return config;
    },
    function (err) {
      try{
         if (err.response.data.message === "Seu token expirou. Por favor, faça login novamente." || err.response.data.message === "Token inválido ou expirado.") {
              localStorage.clear();
              window.location.href = "/login";
          } else {
              return Promise.reject(err);
          }
      }catch(e){
        
      }
       
    }
);
